import store from "@/store"
import { PAGE_REFERENCES, PAGE_REFERENCES_MODULES } from "@/store/constants/references"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
import { utils } from "@/store/helpers"
import dataService from "@/services/data.service"

export class Pages {
  static updateCursorPosition = (event) => {
    const side_bar_collapsed = store.state.ui.is_sidebar_collapsed
    let menu_width
    if (side_bar_collapsed) {
      menu_width = 80
    } else {
      menu_width = 290
    }
    const screenWidth = window.innerWidth
    const cursorX = event.clientX

    const distanceToLeft = cursorX - menu_width
    const distanceToRight = screenWidth - cursorX
    let closestSide

    if (distanceToLeft < distanceToRight) {
      closestSide = "left"
    } else {
      closestSide = "right"
    }

    store.dispatch("ui/setCursorPosition", {
      x: cursorX,
      y: event.clientY,
      closest_side: closestSide
    })
  }

  static getViewMetrics = ({
    page_reference,
    object_type,
    view_type,
    current_forecast_name,
    flat = true,
    layout_page_reference,
    component_reference
  }) => {
    if (!page_reference) {
      return []
    }
    let portfolio = store.state.portfolio
    let views_metrics = store.state.portfolio.views_metrics

    let view_reference
    let full_reference_string
    if (layout_page_reference) {
      if (component_reference) {
        full_reference_string = `${page_reference}>${layout_page_reference}>${component_reference}`
      } else {
        full_reference_string = `${page_reference}>${layout_page_reference}`
      }
    } else {
      full_reference_string = `${page_reference}`
    }

    if (current_forecast_name) {
      view_reference = `${full_reference_string}>${view_type}>${object_type}>${current_forecast_name}`
    } else {
      view_reference = `${full_reference_string}>${view_type}>${object_type}`
    }
    let all_metrics = store.state.metrics.concat([
      {
        type: "field",
        object_type: "record",
        id: "origins",
        sortable: false,
        searchable: true,
        reference_name: "origins",
        name: "Origin",
        data_type: "String"
      },
      {
        object_type: "record",
        id: "parent__id",
        sortable: false,
        searchable: true,
        reference_name: "parent__id",
        type: "field",
        name: "Parent",
        data_type: "String",
        input_type: "Text"
      },
      {
        object_type: "record",
        id: "top_parent",
        sortable: false,
        searchable: true,
        reference_name: "top_parent",
        type: "field",
        name: "Top Parent",
        data_type: "String",
        input_type: "Text"
      },
      {
        object_type: "record",
        id: "owner__id",
        sortable: false,
        searchable: true,
        reference_name: "owner__id",
        type: "field",
        name: "Owner",
        data_type: "String",
        input_type: "Text"
      },
      {
        object_type: "record",
        id: "co_owners__id",
        sortable: false,
        searchable: true,
        reference_name: "co_owners__id",
        type: "field",
        name: "Co-Owners",
        data_type: "List",
        input_type: "Text"
      },
      {
        object_type: "record",
        id: "tags__name",
        sortable: false,
        searchable: true,
        reference_name: "tags__name",
        type: "field",
        name: "Assigned Tags",
        data_type: "List",
        input_type: "Text"
      }
    ])
    let metrics_refs = all_metrics.map((x) => x.reference_name)

    // NOTE: if it is a table we set the included metrics in the layout component props
    if (component_reference && view_type != "form_create" && view_type != "form_update") {
      let layout = portfolio.pages_layout
        ? portfolio.pages_layout[page_reference]?.find((c) => c.name == layout_page_reference || c.slug == layout_page_reference)
        : null
      if (layout) {
        let component = layout.layout.find((l) => l.props.id == component_reference || l.props.component_reference == component_reference)
        if (component?.props?.component_props["includedMetrics"]) {
          let new_list = component?.props?.component_props["includedMetrics"]
          if (flat) {
            return new_list.filter((x) => x && metrics_refs.includes(x))
          } else {
            return new_list
              .filter((x) => x && metrics_refs.includes(x))
              .map((ref) => all_metrics.find((metric) => metric.reference_name == ref))
              .filter((x) => x)
          }
        }
      }
    }

    const returnMetricView = (new_list, update = false) => {
      setTimeout(() => {
        if (update) {
          views_metrics[view_reference] = new_list
          portfolio["views_metrics"] = views_metrics
          store.dispatch("setPortfolio", { views_metrics: views_metrics }, { root: true })
        }
      }, 100)
      if (flat) {
        return new_list.filter((x) => x && metrics_refs.includes(x))
      } else {
        return new_list
          .filter((x) => x && metrics_refs.includes(x))
          .map((ref) => all_metrics.find((metric) => metric.reference_name == ref))
          .filter((x) => x)
      }
    }

    const getViewDefaultMetrics = () => {
      let metrics_mapping = store.state.integration.metrics_mapping
      let default_metrics = []
      if (object_type == "company") {
        default_metrics = [
          metrics_mapping.company_name_metric,
          "owner__id",
          metrics_mapping.company_website_metric,
          metrics_mapping.company_industry_metric,
          "tags__id"
        ]
      } else if (object_type == "contact") {
        default_metrics = [
          "parent__id",
          metrics_mapping.contact_first_name_metric,
          metrics_mapping.contact_last_name_metric,
          metrics_mapping.contact_email_metric
        ]
      } else if (object_type == "opportunity") {
        default_metrics = ["parent__id", metrics_mapping.opportunity_name_metric, metrics_mapping.opportunity_amount_metric]
      } else if (object_type == "department") {
        default_metrics = [metrics_mapping.department_name_metric]
      } else {
        // return first 4
        default_metrics = ["parent__id", utils.getOptionMetricReference(object_type, "name"), "owner__id", "tags__id"]
      }
      if (view_type == "rollups") {
        return default_metrics.filter((ref) => {
          return all_metrics.find((m) => m.reference_name == ref && m.aggregation_method)
        })
      } else {
        return default_metrics.filter((x) => x)
      }
    }

    if (views_metrics) {
      if (view_reference && Object.hasOwn(views_metrics, view_reference)) {
        // if the the same view exists return it
        return returnMetricView(views_metrics[view_reference], false)
      } else {
        // search for similar view and return it
        let similar_reference = null
        //find close sets of included metrics
        if (view_type == "form_create" || view_type == "form_update") {
          // return same level create metrics for update and vice versa
          if (
            view_type == "form_create" &&
            (similar_reference = Object.keys(views_metrics).find(
              (k) => k.search(`${full_reference_string}>form_update>${object_type}`) != -1
            ))
          ) {
            return returnMetricView(views_metrics[similar_reference])
          } else if (
            view_type == "form_update" &&
            (similar_reference = Object.keys(views_metrics).find(
              (k) => k.search(`${full_reference_string}>form_create>${object_type}`) != -1
            ))
          ) {
            return returnMetricView(views_metrics[similar_reference])
          }
          // ignore page and find any same view_type>object_type IE: in any page that the user might've opend the form before
          else if ((similar_reference = Object.keys(views_metrics).find((k) => k.search(`${view_type}>${object_type}`) != -1))) {
            return returnMetricView(views_metrics[similar_reference])
          } else if (
            view_type == "form_create" &&
            (similar_reference = Object.keys(views_metrics).find((k) => k.search(`form_create>${object_type}`) != -1))
          ) {
            return returnMetricView(views_metrics[similar_reference])
          } else if (
            view_type == "form_update" &&
            (similar_reference = Object.keys(views_metrics).find((k) => k.search(`form_update>${object_type}`) != -1))
          ) {
            return returnMetricView(views_metrics[similar_reference])
          } else if (
            view_type == "form_create" &&
            (similar_reference = Object.keys(views_metrics).find((k) => k.search(`form_update>${object_type}`) != -1))
          ) {
            // lastly create form metrics from any update form metrics
            return returnMetricView(views_metrics[similar_reference])
          } else if (
            view_type == "form_update" &&
            (similar_reference = Object.keys(views_metrics).find((k) => k.search(`form_create>${object_type}`) != -1))
          ) {
            // lastly update form metrics from any create form metrics
            return returnMetricView(views_metrics[similar_reference])
          } else {
            return returnMetricView(getViewDefaultMetrics())
          }
        } else if (
          view_type == "table" &&
          (similar_reference = Object.keys(views_metrics).find((k) => k.search(`table>${object_type}`) != -1))
        ) {
          // return any table metrics form same object_type ie: in any page the user viewed the same object in
          return returnMetricView(views_metrics[similar_reference], true)
        } else {
          // return default metrics
          return returnMetricView(getViewDefaultMetrics(), true)
        }
      }
    }
  }

  static setViewMetrics = ({
    page_reference,
    object_type,
    view_type,
    current_forecast_name,
    new_metrics_list,
    layout_page_reference,
    component_reference
  }) => {
    let view_reference
    let full_reference_string

    if (layout_page_reference) {
      if (component_reference) {
        full_reference_string = `${page_reference}>${layout_page_reference}>${component_reference}`
      } else {
        full_reference_string = `${page_reference}>${layout_page_reference}`
      }
    } else {
      full_reference_string = `${page_reference}`
    }

    if (current_forecast_name) {
      view_reference = `${full_reference_string}>${view_type}>${object_type}>${current_forecast_name}`
    } else {
      view_reference = `${full_reference_string}>${view_type}>${object_type}`
    }

    let portfolio = store.state.portfolio
    let views_metrics = portfolio.views_metrics
    views_metrics[view_reference] = new_metrics_list
    portfolio["views_metrics"] = views_metrics
    let changes = { views_metrics: views_metrics }
    // NOTE: if it is a table we set the included metrics in the layout component props
    if (component_reference && view_type != "form_create" && view_type != "form_update") {
      let layout = portfolio.pages_layout ? portfolio.pages_layout[page_reference]?.find((c) => c.slug == layout_page_reference) : null
      if (layout) {
        let component = layout.layout.find((l) => l.props.id == component_reference || l.props.component_reference == component_reference)
        component.props.component_props["includedMetrics"] = new_metrics_list
        utils.replaceItem(layout.layout, component, "id")
        utils.replaceItem(portfolio.pages_layout[page_reference], layout, "id")
        changes["pages_layout"] = portfolio.pages_layout
      }
    }

    store.dispatch("setPortfolio", changes, { root: true }).then((portfolio) => {
      let template_updated = portfolio.pages_layout[page_reference]?.find((c) => c.slug == layout_page_reference)
      if (template_updated && view_type == "table") {
        store.$emitter.emit(ALL_EMITTERS.METRICS_ORDER_UPDATED_IN_TABLE, template_updated)
      }
    })
  }
  static removeMetricsFromView = (reference_names) => {
    let portfolio = store.state.portfolio
    let reference_ids = reference_names.map((ref) => store.state.metrics.find((m) => m.reference_name == ref)?.id)
    let new_set = {}
    Object.keys(portfolio.views_metrics).forEach((key) => {
      Object.keys(portfolio.views_metrics)
      let value = portfolio.views_metrics[key]
      if (value) {
        new_set[key] = value.filter((x) => reference_ids.indexOf(x) == -1)
      } else {
        new_set[key] = value
      }
    })
    let changes = { views_metrics: new_set }
    Object.values(portfolio.pages_layout).forEach((layouts) => {
      layouts.forEach((layout) => {
        layout.layout.forEach((component) => {
          if (component.props.component_props["includedMetrics"]) {
            component.props.component_props["includedMetrics"] = component.props.component_props["includedMetrics"].filter(
              (x) => reference_names.indexOf(x) == -1
            )
          }
        })
      })
    })

    changes["pages_layout"] = portfolio.pages_layout
    store.dispatch("setPortfolio", changes, { root: true })
  }
  static removeObjectTypeFromView = (object_type) => {
    let portfolio = store.state.portfolio
    this.removeMetricsFromView(store.state.metrics.filter((m) => m.object_type == object_type).map((m) => m.reference_name))
    // remove the
    let new_set = {}
    Object.entries(portfolio.pages_layout).forEach(([page, layouts]) => {
      new_set[page] = layouts.filter((layout) => layout.objectType != object_type)
    })
    let changes = { pages_layout: new_set }
    store.dispatch("setPortfolio", changes, { root: true })
  }

  static getPageTabs = ({ page_reference: page_reference, flat = false }) => {
    let portfolio = store.state.portfolio
    let pages_tabs = portfolio.pages_tabs

    if (portfolio.pages_tabs && Object.hasOwn(pages_tabs, page_reference)) {
      if (flat) {
        return pages_tabs[page_reference].filter((x) => x)
      } else {
        return pages_tabs[page_reference].map((t) => store.state.object_types.find((obj) => obj.type == t)).filter((x) => x)
      }
    } else {
      let new_tabs_list = store.state.object_types.map((obj) => obj.type)
      if (page_reference == PAGE_REFERENCES.COMPANY_PROFILE) {
        new_tabs_list = new_tabs_list.filter((ob) => ob != "company")
      }
      if (pages_tabs) {
        pages_tabs[page_reference] = new_tabs_list
      }
      portfolio["pages_tabs"] = pages_tabs
      store.dispatch("setPortfolio", { pages_tabs: pages_tabs }, { root: true })

      if (flat) {
        return new_tabs_list.filter((x) => x)
      } else {
        return new_tabs_list.map((t) => store.state.object_types.find((obj) => obj.type == t)).filter((x) => x)
      }
    }
  }
  static setPageTabs = ({ page_reference, new_tabs_list }) => {
    let portfolio = store.state.portfolio
    let pages_tabs = portfolio.pages_tabs
    pages_tabs[page_reference] = new_tabs_list
    portfolio["pages_tabs"] = pages_tabs
    store.dispatch("setPortfolio", { pages_tabs: pages_tabs }, { root: true })
  }

  static getPageGraphs = ({ page_reference: page_reference, object_type: object_type, flat = false }) => {
    let view_reference = `${page_reference}`
    if (object_type) {
      view_reference = `${page_reference}>${object_type}`
    }
    let portfolio = store.state.portfolio
    let pages_graphs = portfolio.pages_graphs
    if (Object.hasOwn(pages_graphs, view_reference)) {
      if (flat) {
        return pages_graphs[view_reference].filter((x) => x)
      } else {
        return pages_graphs[view_reference].map((t) => store.state.data.all_graphs.find((graph) => graph.order == t)).filter((x) => x)
      }
    } else {
      let new_graphs_list = []
      pages_graphs[view_reference] = new_graphs_list
      portfolio["pages_graphs"] = pages_graphs
      store.dispatch("setPortfolio", { pages_graphs: pages_graphs }, { root: true })

      if (flat) {
        return new_graphs_list.filter((x) => x)
      } else {
        return new_graphs_list.map((t) => store.state.data.all_graphs.find((graph) => graph.order == t)).filter((x) => x)
      }
    }
  }
  static setPageGraphs = ({ page_reference, object_type, new_graphs_list }) => {
    let view_reference = `${page_reference}`
    if (object_type) {
      view_reference = `${page_reference}>${object_type}`
    }
    let portfolio = store.state.portfolio
    let pages_graphs = portfolio.pages_graphs
    pages_graphs[view_reference] = new_graphs_list
    portfolio["pages_graphs"] = pages_graphs
    store.dispatch("setPortfolio", { pages_graphs: pages_graphs }, { root: true })
  }
  static getPageLayout = ({ page_reference: page_reference, object_type: object_type }) => {
    let view_reference = `${page_reference}`
    if (object_type) {
      view_reference = `${page_reference}>${object_type}`
    }
    let portfolio = store.state.portfolio
    let pages_layout = portfolio.pages_layout
    if (Object.hasOwn(pages_layout, view_reference)) {
      return pages_layout[view_reference]
    } else {
      // we get the initial page layout
      let new_layout = this.getModule(PAGE_REFERENCES_MODULES[page_reference]).layout
      if (object_type) {
        new_layout = []
      }
      pages_layout[view_reference] = new_layout
      portfolio["pages_layout"] = pages_layout

      store.dispatch("setPortfolio", { pages_layout: pages_layout }, { root: true })
      return new_layout
    }
  }
  static setPageLayout = (new_layout) => {
    if (new_layout) {
      let portfolio = store.state.portfolio
      let page_reference = new_layout.page
      new_layout.timestamp = new Date().getTime()
      let old_layout = {}
      let is_new_layout = false
      if (new_layout.is_shared && new_layout.owner != store.state.auth.user.id) {
        //NOTE: separate handling of shared layout update (A shared layout edit)
        let shared_layouts = portfolio.shared_layouts
        let index = shared_layouts.findIndex((layout) => layout.id == new_layout.id)

        // replace
        old_layout = utils.clone(shared_layouts[index])
        shared_layouts.splice(index, 1, new_layout)

        portfolio["shared_layouts"] = shared_layouts
        // send the old layout timestamp
        //set timestamp
        new_layout.last_timestamp = old_layout?.timestamp
        store.dispatch(
          "setLayout",
          {
            new_layout: new_layout,
            old_layout: old_layout,
            is_new_layout: is_new_layout
          },
          { root: true }
        )

        return store.dispatch("setPortfolio", { shared_layouts: shared_layouts, is_new_layout: is_new_layout }, { root: true })
      } else {
        let pages_layout = portfolio.pages_layout

        if (page_reference && new_layout.page !== new_layout.name) {
          // if the pages_layout is not an array we create one nad add the new layout
          if (!Array.isArray(pages_layout[page_reference])) {
            pages_layout[page_reference] = [{ ...new_layout }]
            is_new_layout = true
          } else {
            let index = pages_layout[page_reference].findIndex((layout) => layout.id == new_layout.id)
            if (index == -1) {
              pages_layout[page_reference].unshift(new_layout)
              is_new_layout = true
            } else {
              // replace
              old_layout = utils.clone(pages_layout[page_reference][index])
              pages_layout[page_reference].splice(index, 1, new_layout)
            }
          }
          // we check if the new_layout is_active if it is we set the others to false
          if (new_layout.is_active) {
            let layouts = pages_layout[page_reference].map((layout) => {
              if (!(layout.id == new_layout.id)) {
                layout.is_active = false
              }
              return layout
            })
            pages_layout[page_reference] = layouts
          }

          portfolio["pages_layout"] = pages_layout
          new_layout.last_timestamp = old_layout?.timestamp
          store.dispatch(
            "setLayout",
            {
              new_layout: new_layout,
              old_layout: old_layout,
              is_new_layout: is_new_layout
            },
            { root: true }
          )
          return store.dispatch("setPortfolio", { pages_layout: pages_layout, is_new_layout: is_new_layout }, { root: true })
        }
      }
    }
  }
  static updateLayouts = (layout, module_ref) => {
    const pages_layout = store.state.portfolio.pages_layout
    pages_layout[module_ref] = layout
    //set timestamp
    pages_layout[module_ref].timestamp = new Date().getTime()
    return store.dispatch("setPortfolio", { pages_layout: pages_layout }, { root: true })
  }

  static deletePageLayout = (existing_layout) => {
    let portfolio = store.state.portfolio
    let pages_layout = portfolio.pages_layout

    let page_reference = existing_layout.page
    let index = pages_layout[page_reference].findIndex(
      (layout) =>
        layout.name == existing_layout.name && layout.object_type == existing_layout.object_type && layout.page == existing_layout.page
    )

    pages_layout[page_reference].splice(index, 1)

    portfolio["pages_layout"] = pages_layout
    return store.dispatch("setPortfolio", { pages_layout: pages_layout }, { root: true })
  }
  static sharePageWithTeamMember = ({ page: page, users: target_users }) => {
    // tag the original page as shared
    // So we can track it for updates
    if (target_users.length == 0) {
      delete page.shared_with
      delete page.shared_at
      delete page.is_shared
      delete page.is_shared_as_template
    } else {
      page["shared_with"] = target_users
      page["shared_at"] = new Date().toISOString()
      page["owner"] = store.state.auth.user.id
      page["is_shared"] = true
      // safe guard only owner can share
      if (page.owner != store.state.auth.user.id) {
        return
      }
    }
    // update the user page
    let new_layout = page
    let portfolio = store.state.portfolio
    let pages_layout = portfolio.pages_layout
    let old_layout = {}

    let page_reference = new_layout.page

    if (page_reference && new_layout.page !== new_layout.name) {
      if (!Array.isArray(pages_layout[page_reference])) {
        pages_layout[page_reference] = [{ ...new_layout }]
      } else {
        let index = pages_layout[page_reference].findIndex((layout) => layout.id == new_layout.id)
        old_layout = utils.clone(pages_layout[page_reference][index])
        if (index == -1) {
          pages_layout[page_reference].push(new_layout)
        } else {
          // replace
          pages_layout[page_reference].splice(index, 1, new_layout)
        }
      }
      // we check if the new_layout is_active if it is we set the others to false
      if (new_layout.is_active) {
        pages_layout[page_reference] = pages_layout[page_reference].map((layout) => {
          if (!(layout.id == new_layout.id)) {
            layout.is_active = false
          }
          return layout
        })
      }

      portfolio["pages_layout"] = pages_layout

      store.dispatch("setLayout", { new_layout: new_layout, old_layout: old_layout }, { root: true })
      store.dispatch("setPortfolio", { pages_layout: pages_layout }, { root: true })

      store.dispatch("realtime/joinLayoutStreams", portfolio, { root: true })
    }
    return true
  }
  static clonePageToTeamMember = ({ page: page, users: target_users }) => {
    // update cloned_with list
    if (!Array.isArray(page["cloned_with"])) {
      page["cloned_with"] = target_users
    } else {
      page["cloned_with"] = [...page["cloned_with"], ...target_users]
    }
    let portfolio = store.state.portfolio
    let pages_layout = portfolio.pages_layout
    let index = pages_layout[page.page].findIndex((layout) => layout.id == page.id)
    pages_layout[page.page].splice(index, 1, page)
    store.dispatch("setPortfolio", { pages_layout: pages_layout }, { root: true })

    // clone the page to the target users
    let page_copy = utils.clone(page)
    delete page_copy.owner
    delete page_copy.shared_with
    delete page_copy.shared_at
    delete page_copy.cloned_with
    // timestamp
    // utc unix timestamp
    page_copy.cloned_at = new Date().getTime()
    page_copy.original_owner = store.state.auth.user.id

    dataService.cloneLayoutToUsers({ layout: page_copy, target_users: target_users }).then(() => {
      window.$gtag("duplicate_page_click", {
        event_label: "Duplicate page",
        page: page_copy.page,
        name: page_copy.name,
        layout: page_copy.layout
      })
      window.$toast.open({
        message: `Template of page ${page_copy.name} was shared with ${target_users.length} user(s)`,
        position: "top",
        type: "success",
        duration: 3000
      })
    })
    return true
  }
  static canUserEditLayout = (user, layout) => {
    return (
      !layout?.owner ||
      layout?.owner == user?.id ||
      layout?.shared_with?.filter((u) => (u.id == user?.id && u?.access == "admin") || u?.access == "write").length > 0
    )
  }
  static addPageGraph = ({ page_reference, object_type, graph }) => {
    let view_reference = `${page_reference}`
    if (object_type) {
      view_reference = `${page_reference}>${object_type}`
    }
    let portfolio = store.state.portfolio
    let pages_graphs = portfolio.pages_graphs

    if (Object.hasOwn(pages_graphs, view_reference)) {
      pages_graphs[view_reference] = [...pages_graphs[view_reference], graph.order]
    } else {
      pages_graphs[view_reference] = [graph.order]
    }
    portfolio["pages_graphs"] = pages_graphs
    store.dispatch("setPortfolio", { pages_graphs: pages_graphs }, { root: true })
  }
}
